import { useEffect, useState } from 'react';
import useMemberDuesEligibilityFromAPI from '@hooks/apiLegacy/useMemberDuesEligibilityFromAPI';

const useMembershipDuesYears = ({ memberId, duesProductId }) => {
    const [oneOrThreeYears, setOneOrThreeYears] = useState();
    const { memberDuesEligibility } = useMemberDuesEligibilityFromAPI({ id: memberId });

    useEffect(() => {
        if (!memberDuesEligibility || !duesProductId) {
            return;
        }

        const oneYearDues = memberDuesEligibility.dues.find(dues => dues.years === 1);
        const threeYearDues = memberDuesEligibility.dues.find(dues => dues.years === 3);

        const isOneYearSelected = duesProductId === oneYearDues.id;
        const isThreeYearSelected = duesProductId === threeYearDues.id;

        setOneOrThreeYears(isOneYearSelected ? 1 : isThreeYearSelected ? 3 : null); // eslint-disable-line no-nested-ternary
    }, [memberDuesEligibility, duesProductId]);

    return { oneOrThreeYears };
};

export default useMembershipDuesYears;
